import { useState, useEffect } from 'react';
import { Bold, Flex } from './TremorCompat';
import { DatePicker, Panel, Text } from 'rsuite';

import { makeDateFromTime, makeTimeFromDate } from '../utils/registerTime';
import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

export const DisplayTimePickerItem = ({
  register,
  tc = /** @type {any} */ (undefined),
  icon = /** @type {any} */ (undefined),
  onChange,
  borderOff = false,
  disabled = false,
}) => {
  const [value, setValue] = useState(/** @type {any} */ (null));

  // pickedDate is a Date|null from the DatePicker — a different domain than
  // the packed hi/lo integer `value` state above; kept distinctly named so
  // the two representations can't get mixed up in a future edit.
  const updateValue = (pickedDate, event) => {
    devLog('Date time picker Changed', event, pickedDate);
    // rsuite's DatePicker is cleanable by default — clearing it calls onChange
    // with null. Packing that would resolve to a real 00:00, silently writing
    // midnight to the device register; treat clearing as a no-op instead.
    if (pickedDate === null) {
      return;
    }
    setValue(makeTimeFromDate(pickedDate));
    onChange(register, pickedDate);
  };

  useEffect(() => {
    setValue(register.value);
  }, [register.value]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      {/* <div style={ borderOff === true ?({border:"none"}):({border:"1px solid",borderColor: "lightgray", borderRadius:"5px", padding:"5px", boxShadow:"1px -1px 0 lightgray"  })}  >  */}
      <Flex justifyContent="start" className="space-x-4 ">
        <DisplayIcon icon={icon} />

        <div
          style={{
            display: 'block',
            width: '40%',
          }}
          className="truncate space-y-0.5 w-1/4"
        >
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{register.display}</Bold>
          </Text>
        </div>

        <div
          style={{
            display: 'block',
            width: '60%',
          }}
        >
          <Flex justifyContent="end" className="space-x-4">
            <DatePicker
              format=" HH:mm "
              ranges={[]}
              // size="sm"
              value={makeDateFromTime(value)}
              onChange={updateValue}
              disabled={disabled}
              cleanable={false}
              // hideSeconds={true}
            />
          </Flex>
        </div>
      </Flex>
    </Panel>
    // </div>
  );
};
